/**
 * theme
 * Selectable theme stored in localStorage and applied via [data-theme] on <html>.
 */

const THEMES = ['scroll', 'paper'];

export function getTheme() {
  const t = localStorage.getItem('theme');
  // ponytail: old stored values ('light'/'dark') fall through to the default
  return THEMES.includes(t) ? t : 'scroll';
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export function toggleTheme() {
  const next = THEMES[(THEMES.indexOf(getTheme()) + 1) % THEMES.length];
  localStorage.setItem('theme', next);
  applyTheme(next);
  return next;
}
